import { createFileRoute } from '@tanstack/react-router'
import OpportunityManagementViewer from '@/opportunity/OpportunityManagementViewer'
import React from 'react'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/issues/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { organizationId } = Route.useParams()
  return <OpportunityManagementViewer organizationId={organizationId} />
}
